export function ThumbsUpIcon({ ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' {...props}>
      <path
        id='Icon_feather-thumbs-up'
        data-name='Icon feather-thumbs-up'
        d='M14.268,17.5H3.714A2.2,2.2,0,0,1,1.5,15.318V10.227A2.2,2.2,0,0,1,3.714,8.045H5.448L8.2,1.932A.738.738,0,0,1,8.879,1.5a2.934,2.934,0,0,1,2.952,2.909V6.591h3.435a2.224,2.224,0,0,1,1.691.75A2.157,2.157,0,0,1,17.475,9.1l-1.018,6.547a2.173,2.173,0,0,1-.755,1.334A2.233,2.233,0,0,1,14.268,17.5Zm-7.6-1.455h7.6a.738.738,0,0,0,.73-.618l1.019-6.547a.718.718,0,0,0-.173-.585.741.741,0,0,0-.565-.25H11.093a.733.733,0,0,1-.738-.727V4.409A1.46,1.46,0,0,0,9.328,3.023l-2.662,5.9ZM3.714,9.5a.733.733,0,0,0-.738.727v5.091a.733.733,0,0,0,.738.727H5.19V9.5Z'
        transform='translate(-1.5 -1.5)'
        fill='currentColor'
      />
    </svg>
  )
}
